import { useGetAllCountries } from '@/hooks/data/masterDataHook';
import { Select, SelectProps } from 'antd';
import React from 'react';

interface Props extends SelectProps<any> {
  isOperatingOnly?: boolean;
}
export default function CountryCodeInput({ isOperatingOnly = true, ...props }: Props) {
  const { data, isLoading } = useGetAllCountries(isOperatingOnly);
  return (
    <Select
      maxTagCount="responsive"
      allowClear
      loading={isLoading}
      {...props}
      filterOption={(input, option) => {
        return (option?.children as any)?.toLowerCase().includes(input.toLowerCase());
      }}
      showSearch={true}
    >
      {data?.data?.map(c => {
        return (
          <Select.Option key={c.id} value={c.alphaCode}>
            {c.alphaCode}
          </Select.Option>
        );
      })}
    </Select>
  );
}
